// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3q8a1","label":"styles_label__ceH54","input":"styles_input__Adsi0","section":"styles_section__P_OSp"};